// extracted by mini-css-extract-plugin
export var footer = "_r8-5";
export var fulfillmentInput = "_r8-0";
export var shipDateInput = "_r8-1";
export var shipmentModal = "_r8-2";
export var shipmentModalContent = "_r8-3";
export var tableContainer = "_r8-4";